module.exports = __webpack_public_path__ + "img/84.095098b1.png";